import { css } from 'linaria';

export const animateIn = css`
  @media (prefers-reduced-motion: no-preference) {
    animation: animateIn 0.25s;
  }
  @keyframes animateIn {
    from {
      opacity: 0;
      transform: translateX(100px);
    }
    to {
      opacity: 1;
      transform: translateX(0);
    }
  }
`;
